module.exports = "mutation AcceptCampaignShare($id: ID!) {\n  acceptCampaignShare(id: $id) {\n    campaign {\n      ...CampaignFragment\n    }\n  }\n}\n"